export default __webpack_public_path__ + "static/8-9cd3059679a5ee1dc5b2621e47288445.png";